module.exports = __webpack_public_path__ + "static/media/404.0781d6e7.svg";